let _disabledConsoleDebug = undefined as typeof console.debug | undefined;

export function disableDebugLog() {
  _disabledConsoleDebug = console.debug;
  console.debug = () => {};
}

export function enableDebugLog() {
  if (!_disabledConsoleDebug) return;
  console.debug = _disabledConsoleDebug;
}

export function toggleDebugLog() {
  if (_disabledConsoleDebug) {
    enableDebugLog();
  } else {
    disableDebugLog();
  }
}
